import type { MentionDto } from '@/entities/mentions'
import type { SuggestionKeyDownProps } from '@tiptap/suggestion'

import { TiptapSuggestionsConfig } from '@/entities/tiptap-suggestions'

export const MENTIONSNODE_NAME = 'rsMentionNode' as const
export const MENTIONSNODE_TAG = 'rs-mention' as const

/** @deprecated We're migrating from `<custom-mention/>` to `<rs-mention/>` */
export const MENTIONSNODE_TAG_LEGACY = 'custom-mention' as const

export const mentionsExtensionConfig = new TiptapSuggestionsConfig({
  name: MENTIONSNODE_NAME,
  nodeTag: MENTIONSNODE_TAG,
  character: '@',
  supportedNavigationKeys: ['ArrowUp', 'ArrowDown', 'Enter'],
})

export type MentionSuggestionsCommandReturn = {
  mention: MentionDto
}

export interface MentionSuggestionsHandle {
  onKeyDown: (props: SuggestionKeyDownProps) => boolean
}
